// extracted by mini-css-extract-plugin
module.exports = {"breakpointXS":"0","breakpointSM":"600","breakpointMD":"900","breakpointLG":"1200","breakpointXL":"1400"};